export default "__VITE_ASSET__3e71ae9c__"